import React from 'react';
import Navbar from './Components/Navbar';
import Hero from './Components/Hero';
import About from './Components/About';
import Features from './Components/Features';
import Contact from './Components/Contact';
import Footer1 from './Components/Footer1';
import MyChatBot from './Chatbot';

export default function App() {
  return (
    <div className="bg-[#181818] min-h-screen">
      <MyChatBot/>
      <Navbar />
      <div id="home">
        <Hero />
      </div>
      <div id="features">
        <Features />
      </div>
      <div id="about">
        <About />
      </div>
  
      <div id="contact">
        <Contact />
      </div>
      <Footer1 />
    </div>
    
  );
}
